<script>
    import { client, gql } from "../../GraphQL.svelte";
    import { approveContribution, rejectContribution } from "../../Participaid.svelte";
    import { faTrash } from '@fortawesome/free-solid-svg-icons';
    import { pencil } from 'svelte-awesome/icons';
    import Icon from 'svelte-awesome';

    import DataTable, {Head, Body, Row, Cell} from '@smui/data-table';

    export let model;
</script>

{#if !model}
    ...
{:else}
    <DataTable class="project-financials">
        <!--                    <Head>-->
        <!--                        <Row>-->
        <!--                            <Cell></Cell>-->
        <!--                            <Cell>Value</Cell>-->
        <!--                            <Cell></Cell>-->
        <!--                            &lt;!&ndash;                <Cell>Tags</Cell>&ndash;&gt;-->
        <!--                            <Cell>Status</Cell>-->
        <!--                            <Cell>Actions</Cell>-->
        <!--                        </Row>-->
        <!--                    </Head>-->
        <Body>
            <Row class="contribution-table-item">
                <Cell class="prop">
                    Company valuation:
                </Cell>
                <Cell class="value">
                    {(model.totalOrganisationWorth / 100).toFixed(2)}
                </Cell>
            </Row>
            <Row class="contribution-table-item">
                <Cell class="prop">
                    Total contribution value:
                </Cell>
                <Cell class="value">
                    {(model.totalContributionWorth / 100).toFixed(2)}
                </Cell>
            </Row>
            <Row class="contribution-table-item">
                <Cell class="prop">
                    Total company stock available:
                </Cell>
                <Cell class="value">
                    {model.totalStockNumber}
                </Cell>
            </Row>
            <Row class="contribution-table-item">
                <Cell class="prop">
                    Stock price:
                </Cell>
                <Cell class="value">
                    €{(model.pricePerStock / 100).toFixed(2)}
                </Cell>
            </Row>
            <Row class="contribution-table-item">
                <Cell class="prop">
                    Total stock earned:
                </Cell>
                <Cell class="value">
                    {model.totalAvailableStocks}
                </Cell>
            </Row>
            <Row class="contribution-table-item">
                <Cell class="prop">
                    Total stock undistributed:
                </Cell>
                <Cell class="value">
                    {model.undistributedStocks}
                </Cell>
            </Row>
        </Body>
    </DataTable>
{/if}

<style>
    :global(.project-financials .prop) {
        font-weight: bold;
    }
</style>